module.exports = __webpack_public_path__ + "static/media/3-min.a8733227.png";